module.exports = __webpack_public_path__ + "img/exam_no_data@2x.9de3e77e.png";